import { Injectable, inject, computed } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Observable, map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  private breakpointObs = inject(BreakpointObserver);

  private observePortrait(): Observable<BreakpointState> {
    return this.breakpointObs.observe('(orientation: portrait)');
  }

  private observeMobile(): Observable<BreakpointState> {
    return this.breakpointObs.observe('(max-width: 1000px)');
  }

  isPortrait = toSignal(this.observePortrait().pipe(map((x) => (x.matches ? true : false))));

  widthMax767 = toSignal(this.breakpointObs.observe('(max-width: 767px)').pipe(map((x) => (x.matches ? true : false))));
  heightMax767 = toSignal(
    this.breakpointObs.observe('(max-height: 767px)').pipe(map((x) => (x.matches ? true : false)))
  );

  isMobile = toSignal(this.observeMobile().pipe(map((x) => (x.matches ? true : false))));

  isPortrait$() {
    return this.observePortrait().pipe(map((x) => (x.matches ? true : false)));
  }

  isMobile$() {
    return this.observeMobile().pipe(map((x) => (x.matches ? true : false)));
  }

  isNavigationMobileMode = computed(() => {
    return this.widthMax767();
  });
}
